import AdminListYoungPeopleScreen from './AdminListYoungPeopleScreenContainer';
export default AdminListYoungPeopleScreen;
